import React, { useState, useEffect } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import { Box, Button, Alert, Snackbar } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { put, get } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import CustomTextField from "../GRI308/CustomTextField";
import SectionHeading from "../GRI308/SectionHeading";

import ReviewBox from "../../../../Components/Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";

const GRI304_2 = ({hide}) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
    const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));
const [snackOpen, setSnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [formData, setFormData] = useState({
    natureOfImpact: {
      constructions: "",
      pollution: "",
      introductionOfInvasives: "",
      reduction: "",
      habitatConversion: "",
      ecologicalProcess: "",
    },
    // B
    positiveorNegativeImpact: {
      spceciesAffected: "",
      extendImpacts: "",
      impactPersist: "",
      reversible: "",
    },
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(`/gri/get?Id=${id}&type=GRI300`);
        if (response?.data?.data?.year < currentYear - 1) setDisabled(true);
        const data = response.data.data.GRI300?.significantImpact || {};
        setFormData({
          natureOfImpact: {
            constructions: data.natureOfImpact?.constructions || "",
            pollution: data.natureOfImpact?.pollution || "",
            introductionOfInvasives:
              data.natureOfImpact?.introductionOfInvasives || "",
            reduction: data.natureOfImpact?.reduction || "",
            habitatConversion: data.natureOfImpact?.habitatConversion || "",
            ecologicalProcess: data.natureOfImpact?.ecologicalProcess || "",
          },
          positiveorNegativeImpact: {
            spceciesAffected:
              data.positiveorNegativeImpact?.spceciesAffected || "",
            extendImpacts: data.positiveorNegativeImpact?.extendImpacts || "",
            impactPersist: data.positiveorNegativeImpact?.impactPersist || "",
            reversible: data.positiveorNegativeImpact?.reversible || "",
          },
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleNestedInputChange = (section, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value,
      },
    }));

    // Remove error for the specific field
    if (value.trim()) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const validateForm = () => {
    let newErrors = {};
    let formIsValid = true;

    // Validate sector

    // Validate required fields in the formData

    if (!formData.natureOfImpact.constructions) {
      newErrors.constructions = "This field is required";
      formIsValid = false;
    }

    if (!formData.natureOfImpact.pollution) {
      newErrors.pollution = "This field is required";
      formIsValid = false;
    }

    if (!formData.natureOfImpact.reduction) {
      newErrors.reduction = "This field is required";
      formIsValid = false;
    }

    if (!formData.natureOfImpact.habitatConversion) {
      newErrors.habitatConversion = "This field is required";
      formIsValid = false;
    }

    if (!formData.natureOfImpact.ecologicalProcess) {
      newErrors.ecologicalProcess = "This field is required";
      formIsValid = false;
    }

    if (!formData.natureOfImpact.introductionOfInvasives) {
      newErrors.introductionOfInvasives = "This field is required";
      formIsValid = false;
    }

    //   SectionB
    if (!formData.positiveorNegativeImpact.spceciesAffected) {
      newErrors.spceciesAffected = "This field is required";
      formIsValid = false;
    }

    if (!formData.positiveorNegativeImpact.extendImpacts) {
      newErrors.extendImpacts = "This field is required";
      formIsValid = false;
    }

    if (!formData.positiveorNegativeImpact.impactPersist) {
      newErrors.impactPersist = "This field is required";
      formIsValid = false;
    }

    if (!formData.positiveorNegativeImpact.reversible) {
      newErrors.reversible = "This field is required";
      formIsValid = false;
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      // if (!validateForm()) return;
      const payload = {
        type: "GRI300",
        submitted304_2: true,
        significantImpact: {
          ...formData,
        },
      };

      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        await put(`/gri/update?Id=${id}`, payload);
        navigate(`/gri/gri300/304-3/${id}`);
      } catch (error) {
        setSnackOpen({
          open: true,
          message: "Error updating data. Please try again.",
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/gri300/304-3/${id}`);
    }
  };


  const renderContent = ({hide}) => (
     <>
      {!hide && <p className={styles.section_heading}>304 : Biodiversity</p>}
      <p className={styles.main_heading} style={{marginBottom : hide ? "-1rem" : "0", }}>
        304-2 : Significant impacts of activities, products and services on
        biodiversity
      </p>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        {/* Section A */}

        <SectionHeading text="a. Define the nature of significant direct and indirect impacts on biodiversity with reference to the following:" />

        <Box sx={{ marginLeft: "1.1rem" }}>
          <SectionHeading
            text="i. Construction or utilization of manufacturing plants, mines, and transport infrastructure."
            sx={{ marginTop: "-0.3rem" }}
          />
          <CustomTextField
            value={formData.natureOfImpact.constructions}
            onChange={(e) =>
              handleNestedInputChange(
                "natureOfImpact",
                "constructions",
                e.target.value
              )
            }
            error={errors.constructions}
            helperText={errors.constructions}
            disabled={disabled}
          />

          <SectionHeading text="ii. Pollution: Describe the introduction of substances that do not naturally occur in the habitat, considering both point and non-point sources." />
          <CustomTextField
            value={formData.natureOfImpact.pollution}
            onChange={(e) =>
              handleNestedInputChange(
                "natureOfImpact",
                "pollution",
                e.target.value
              )
            }
            error={errors.pollution}
            helperText={errors.pollution}
            disabled={disabled}
          />

          <SectionHeading text="iii. Introduction of invasive species, pests, and pathogens." />
          <CustomTextField
            value={formData.natureOfImpact.introductionOfInvasives}
            onChange={(e) =>
              handleNestedInputChange(
                "natureOfImpact",
                "introductionOfInvasives",
                e.target.value
              )
            }
            error={errors.introductionOfInvasives}
            helperText={errors.introductionOfInvasives}
            disabled={disabled}
          />

          <SectionHeading text="iv. Reduction of species: Assess any observed decline in species abundance or diversity." />
          <CustomTextField
            value={formData.natureOfImpact.reduction}
            onChange={(e) =>
              handleNestedInputChange(
                "natureOfImpact",
                "reduction",
                e.target.value
              )
            }
            error={errors.reduction}
            helperText={errors.reduction}
            disabled={disabled}
          />

          <SectionHeading text="v. Habitat conversion: Identify any activities leading to the conversion of habitats (e.g., deforestation, wetland draining)." />
          <CustomTextField
            value={formData.natureOfImpact.habitatConversion}
            onChange={(e) =>
              handleNestedInputChange(
                "natureOfImpact",
                "habitatConversion",
                e.target.value
              )
            }
            error={errors.habitatConversion}
            helperText={errors.habitatConversion}
            disabled={disabled}
          />

          <SectionHeading text="vi. Changes in ecological processes outside the natural range of variation (e.g., alterations in salinity, groundwater levels)." />
          <CustomTextField
            value={formData.natureOfImpact.ecologicalProcess}
            onChange={(e) =>
              handleNestedInputChange(
                "natureOfImpact",
                "ecologicalProcess",
                e.target.value
              )
            }
            error={errors.ecologicalProcess}
            helperText={errors.ecologicalProcess}
            disabled={disabled}
          />
        </Box>

        <SectionHeading text="b. Define significant direct and indirect positive and negative impacts with reference to the following:" />
        <Box sx={{ marginLeft: "1.1rem" }}>
          <SectionHeading
            text="i. Which species are affected by the identified impacts?"
            sx={{ marginTop: "-0.3rem" }}
          />
          <CustomTextField
            value={formData.positiveorNegativeImpact.spceciesAffected}
            onChange={(e) =>
              handleNestedInputChange(
                "positiveorNegativeImpact",
                "spceciesAffected",
                e.target.value
              )
            }
            error={errors.spceciesAffected}
            helperText={errors.spceciesAffected}
            disabled={disabled}
          />

          <SectionHeading text="ii. What is the extent of the impacted areas as a result of the identified impacts?" />
          <CustomTextField
            value={formData.positiveorNegativeImpact.extendImpacts}
            onChange={(e) =>
              handleNestedInputChange(
                "positiveorNegativeImpact",
                "extendImpacts",
                e.target.value
              )
            }
            error={errors.extendImpacts}
            helperText={errors.extendImpacts}
            disabled={disabled}
          />

          <SectionHeading text="iii. How long do the impacts persist or affect the environment?" />
          <CustomTextField
            value={formData.positiveorNegativeImpact.impactPersist}
            onChange={(e) =>
              handleNestedInputChange(
                "positiveorNegativeImpact",
                "impactPersist",
                e.target.value
              )
            }
            error={errors.impactPersist}
            helperText={errors.impactPersist}
            disabled={disabled}
          />

          <SectionHeading text="iv. Are the identified impacts reversible, or are they irreversible in nature?" />
          <CustomTextField
            value={formData.positiveorNegativeImpact.reversible}
            onChange={(e) =>
              handleNestedInputChange(
                "positiveorNegativeImpact",
                "reversible",
                e.target.value
              )
            }
            error={errors.reversible}
            helperText={errors.reversible}
            disabled={disabled}
          />
        </Box>

        {/* Submit Button */}
       

        {/* Snackbar for success/error messages */}
        <Snackbar
          open={snackOpen.open}
          message={snackOpen.message}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={() => setSnackOpen({ ...snackOpen, open: false })}
        >
          <Alert
            severity={snackOpen.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackOpen.message}
          </Alert>
        </Snackbar>
      </Box>
    </>
  )

  return (
     <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
             {!griReview ? (
          <Box sx={{ ml: "1rem", width: "98%" }}>
            <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
          </Box>
        ) : (
          <Box textAlign="right" sx={{ mt: 3 }}>
            <Button
              variant="contained"
              sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
              onClick={handleSubmit}
            >
              Save & Continue <EastIcon sx={{ ml: 2 }} />
            </Button>
          </Box>
        )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI304_2;
